<div class="row bg-white p-3 mt-2">
    <div class="col-md-12 text-center">
        <h5 class="text-primary pb-2">{{ headingText }}</h5>
    </div>
    <div class="data-grid bg-gray table-responsive pb-0">
        <table mat-table [dataSource]="datasource" class="table">
            <ng-container matColumnDef="fileName">
                <th mat-header-cell *matHeaderCellDef class="col-2">File Name</th>
                <td mat-cell *matCellDef="let element" class="fileName">
                    {{
                    element.originalFileName
                    }}
                    <span *ngIf="openButtonText !== 'Video'">
                        <br />{{ element.imageCount > 1 ? "(+" + (element.imageCount -1) + ")" : "" }}
                    </span>
                </td>
            </ng-container>
            <!--<ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef class="w-4-rem">Date</th>
      <td mat-cell *matCellDef="let element">
        {{ element.studyStatusDate | date : "medium" }}
      </td>
    </ng-container>-->
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef class="col-2">
                    <span *ngIf="openButtonText == 'Video'">Video Type</span>
                    <span *ngIf="openButtonText !== 'Video'">Images</span>
                </th>
                <td mat-cell *matCellDef="let element">
                    <label *ngIf="openButtonText == 'Video'">

                        {{element.documentTypeName}}

                    </label>
                    <label class="no-click" *ngIf="openButtonText !== 'Video'">
                        <!-- X-Ray Report 1 -->
                        {{ element.imageCount > 0 ? "(" + element.imageCount + ")" : "" }}
                        {{ openButtonText }}{{ element.imageCount > 1 ? "s" : "" }}
                    </label>
                </td>
            </ng-container>
            <ng-container matColumnDef="details">
                <th mat-header-cell *matHeaderCellDef class="col-1">Format</th>
                <td mat-cell *matCellDef="let element">{{ element.mimeType }}</td>
            </ng-container>
            <ng-container matColumnDef="uploadedby">
                <th mat-header-cell *matHeaderCellDef class="col-2">Uploaded By</th>
                <td mat-cell *matCellDef="let element">{{ element.createdByUser?.name }}</td>
            </ng-container>
            <ng-container matColumnDef="uploadeddate">
                <th mat-header-cell *matHeaderCellDef class="col-2">Uploaded Date/Time</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.createdDate | date }}
                    {{ element.createdDate | date : "hh:mm:ss a" }}
                </td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="col-1">
                    <div class="d-flex align-items-center">
                        <mat-checkbox (change)="toggleAllRows()" [checked]="isAllSelected()"
                            [disabled]="isAllDisabled()" [indeterminate]="selection.hasValue() && !isAllSelected()"
                            *ngIf="isSalesCompany">
                        </mat-checkbox>
                        <span class="ms-2">Status</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div class="d-flex align-items-center flex-row gap-1">
                        <mat-checkbox
                            [disabled]="element.originalStatus == StudyStatus.Approved || element.originalStatus == StudyStatus.Denied"
                            (change)="toggleRow(element)" [checked]="selection.isSelected(element)"
                            *ngIf="isSalesCompany">
                        </mat-checkbox>
                        <div class="select-box">
                            <select (change)="onChangeStatus($event, element, element.studyFileIds)"
                                class="form-control custom-form-select dropdown-arrow text-white fs-13 study-status-box study-status-box-{{ element.status }}"
                                [(ngModel)]="element.status"
                                *ngIf="isUserSaleEditor && element.originalStatus != StudyStatus.Denied">
                                <ng-container *ngFor="let status of statuses">
                                    <option
                                        *ngIf="status.id > StudyStatus.Draft"
                                        [value]="status.id">
                                        {{ status.altName }}
                                    </option>
                                </ng-container>
                            </select>
                            <span
                                *ngIf="!isUserSaleEditor || element.originalStatus == StudyStatus.Denied"
                                class="form-control study-status-box study-status-box-{{ element.status }}">
                                {{ getStatusName(element.status) }}
                            </span>
                        </div>
                    </div>
                </td>
            </ng-container>


            <ng-container matColumnDef="comment">
                <th mat-header-cell *matHeaderCellDef class="col-1">Comment</th>
                <td mat-cell *matCellDef="let element">
                    <span class="d-block ms-1">{{ element.statusMessage }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="col"></th>
              <td mat-cell *matCellDef="let studyFile" class="white-space-no-wrap">

                <!-- SalesCompany case -->
                <ng-container *ngIf="isSalesCompany; else vet">


                  <button *ngIf="openButtonText === 'Video'"
                          class="btn btn-outline-info me-2"
                          (click)="emitOpenButtonClicked(studyFile.studyFileIds)">
                    PREVIEW
                  </button>


                  <ng-container *ngIf="openButtonText !== 'Video'">

                    <button *ngIf="studyFile.originalStatus === StudyStatus.Submitted; else salesPreview"
                            class="btn btn-outline-info me-2"
                            (click)="emitManageButtonClicked(studyFile.studyFileIds)">
                      MANAGE
                    </button>

                    <ng-template #salesPreview>
                      <button class="btn btn-outline-info me-2"
                              (click)="emitOpenButtonClicked(studyFile.studyFileIds)">
                        PREVIEW
                      </button>
                    </ng-template>
                  </ng-container>

                  <button class="btn btn-outline-primary"
                          (click)="emitDownloadButtonClicked(studyFile.studyFileIds)">
                    <i class="fa fa-download"></i>
                  </button>

                </ng-container>

                <!-- Vet case -->
                <ng-template #vet>
                  <button class="btn btn-outline-info me-2"
                          (click)="emitOpenButtonClicked(studyFile.studyFileIds)">
                    PREVIEW
                  </button>
                </ng-template>

             
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-start-0 border-end-0 pt-2"></tr>
        </table>

    </div>
</div>
